import { SVGProps, Ref, forwardRef } from 'react';

export const BarsOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M20 6.8H4V5h16z" fill="currentColor" />
            <path d="M20 12.9H4v-1.8h16z" fill="currentColor" />
            <path d="M4 19h16v-1.8H4z" fill="currentColor" />
        </g>
    </svg>
));
BarsOutlinedSize24Glyph.displayName = 'BarsOutlinedSize24Glyph';
